import { createApi } from '@reduxjs/toolkit/query/react'
import { ExportRequest, MutationResponse } from 'services/OpsManagement/types'
import { reportsApi } from 'services/ReportManagement/reports'
import axiosBaseQuery from 'services/axiosBaseQuery'
import { TableResponse, TableRequest } from 'services/types'
import { sendExportNotification } from 'utils'

export const activityApi = createApi({
  reducerPath: 'activityApi',
  tagTypes: ['Activities'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/asset/'}`,
  }),
  endpoints: (builder) => ({
    getActivitiesList: builder.query<TableResponse<any>, TableRequest & { asset_id?: number }>({
      query: ({ clientId, ...data }) => ({
        url: `clients/${clientId}/activities/`,
        method: 'POST',
        data,
      }),
      providesTags: ['Activities'],
    }),
    exportActivities: builder.mutation<MutationResponse, ExportRequest>({
      query: ({ client_id, ...data }) => ({
        url: `clients/${client_id}/export_activities/`,
        method: 'POST',
        data,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          sendExportNotification(data.detail.message)
          dispatch(reportsApi.util.invalidateTags(['ExportReports']))
        } catch (error) {}
      },
    }),
  }),
})

export const { useGetActivitiesListQuery, useExportActivitiesMutation } = activityApi
